"use strict";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
import $ from "jquery";
import "typeahead.js";
$.fn.typeahead = $.fn.typeahead.noConflict();
function restingDisplay(props, item) {
  return props.display(item).replace(/<br>/g, " - ");
}
function focused(props, e) {
  if (props.onFocus) {
    props.onFocus(e);
  }
}
function keyPress(props, state, e) {
  if (e.charCode === 13) {
    e.preventDefault();
    if (state.selectedItem && props.onSubmit) {
      props.onSubmit();
    }
  }
}
function stateFromProps(props, newProps) {
  return {
    term: newProps.selectedItem ? restingDisplay(props, newProps.selectedItem) : "",
    selectedItem: newProps.selectedItem
  };
}
var TypeAhead = React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    return stateFromProps(this.props, this.props);
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.selectedItem !== newProps.selectedItem) {
      this.setState(stateFromProps(this.props, newProps));
    }
  },
  componentDidMount: function() {
    var component = this;
    var element = ReactDOM.findDOMNode(this);
    $(element).typeahead(
      {
        minLength: 1,
        highlight: false
      },
      {
        name: "type-ahead",
        displayKey: function(c) {
          return c ? restingDisplay(this.props, c) : "";
        }.bind(this),
        source: function(term, callback) {
          if (this.props.remoteSearch) {
            this.props.remoteSearch(term).then(function(data) {
              callback(data);
            });
          } else {
            callback(this.props.search(term));
          }
        }.bind(this),
        templates: {
          empty: '<div class="tt-no-matches">No matches found</div>',
          suggestion: function(match) {
            return this.props.display(match);
          }.bind(this)
        }
      }
    );
    var selectItem = function(typeaheadEvent, item) {
      component.setState({
        term: restingDisplay(component.props, item),
        selectItem: item
      });
      component.props.onSelectItem(item);
      $(element).typeahead("close");
    };
    $(element).on("typeahead:selected", selectItem);
    $(element).on("typeahead:autocompleted", selectItem);
    $(element).on("typeahead:closed", function(jquery, item) {
      if (!component.state.selectedItem && !component.props.readOnly) {
        component.setState({
          term: ""
        });
        component.props.onClearSelectedItem();
      }
      if (_.isEmpty(element.value) && !_.isEmpty(component.state.term)) {
        $(element).typeahead("val", component.state.term);
      }
    });
  },
  componentWillUnmount: function() {
    var element = ReactDOM.findDOMNode(this);
    $(element).typeahead("destroy");
  },
  myLinkState: function(field) {
    return {
      value: this.state[field],
      requestChange: function(value) {
        var newState = {};
        newState[field] = value;
        this.setState(newState);
        this.setState({ selectedItem: null });
        if (value === "") {
          const onClearSelectedItem = this.props.onClearSelectedItem;
          if (onClearSelectedItem) {
            this.props.onClearSelectedItem();
          }
        }
      }.bind(this)
    };
  },
  dropped: function(term) {
    var element = ReactDOM.findDOMNode(this);
    this.setState({ selectedItem: null, term });
    $(element).trigger("focus");
    $(element).trigger("input");
  },
  render: function() {
    if (this.props.isDroppable) {
      return /* @__PURE__ */ React.createElement(
        ValueLinkTextDroppableInput,
        {
          "data-component": "TypeAhead",
          type: "text",
          typeahead: true,
          disabled: this.props.readOnly,
          valueLink: this.myLinkState("term"),
          inputDropped: this.dropped,
          onFocus: (e) => focused(this.props, e),
          className: "carrier-setter__typeahead mousetrap-allow-text",
          placeholder: this.props.placeHolder,
          onKeyPress: (e) => keyPress(this.props, this.state, e),
          showTextArea: this.props.showTextArea
        }
      );
    } else {
      if (this.props.showTextArea) {
        return /* @__PURE__ */ React.createElement(
          "textarea",
          {
            type: "text",
            disabled: this.props.readOnly,
            valueLink: this.myLinkState("term"),
            onFocus: (e) => focused(this.props, e),
            className: "carrier-setter__typeahead mousetrap-allow-text",
            placeholder: this.props.placeHolder,
            onKeyPress: (e) => keyPress(this.props, this.state, e),
            rows: 1
          }
        );
      } else {
        return /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            disabled: this.props.readOnly,
            valueLink: this.myLinkState("term"),
            onFocus: (e) => focused(this.props, e),
            className: "carrier-setter__typeahead mousetrap-allow-text",
            onKeyPress: (e) => keyPress(this.props, this.state, e),
            placeholder: this.props.placeHolder
          }
        );
      }
    }
  }
});
export default TypeAhead;
